/**
 * Lightweight URL param parser for lang, brand, and theme.
 * Used by preloaders (theme, translations) and the main app
 * to ensure consistent parsing from a single source of truth.
 *
 * NOTE: This module must stay free of heavy imports (Redux, React, etc.)
 * because it runs before the app bootstraps.
 */

export interface InitialParams {
  lang: string;
  brand: string;
  theme: string;
}

export const getInitialParams = (): InitialParams => {
  const params = new URLSearchParams(window.location.search);
  const langParam = params.get('lang') || '';
  const [lang = 'en', brand = ''] = langParam.split('-');
  const theme = params.get('theme') || '';

  return {
    lang,
    brand,
    theme,
  };
};
